import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Caption.js';
import '../../icons/index.es.js';
import ErrorIcon from '../../icons/components/ErrorIcon.js';

const ErrorText = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const classes = classNames(className, styles.caption, styles.errorText);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement(ErrorIcon, {
    size: "small",
    className: styles.errorIcon,
    "aria-hidden": "true"
  }), children);
});

export { ErrorText as default };
